import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import "./LinkGroup.scss";

import CTALink_Module from "../../modules/cta_menu_link_module";

const LinkGroup = ({Module}) => {

  const handleShow = event => {
    event.currentTarget.classList.toggle('active-menu');
  };

  
  return (
    <>
      <section className="link-group">
        <Container>

          <Row>
            <Col>
              <h2>{Module?.heading}</h2>
              <p>{Module?.content}</p>
            </Col>
          </Row>
          <Row className="what_we_are_link_row">
            {Module?.page_links?.length > 0 && Module?.page_links.map((item, index) => (
              <Col key={index} className="col-12 col-md-6 col-xl-3 what_we_are_link">
                <div className="link-block">
                  <strong onClick={handleShow}>{item.title}
                    <i className="icon-show d-md-none"></i>
                  </strong>
                  <ul>
                    {item.menu_link &&
                      item.menu_link.map((newitem, i) => (
                        <li key={i}>
                          <CTALink_Module item={newitem}/>
                        </li>
                      ))}
                  </ul>
                </div>

              </Col>
            ))}
          </Row>
        </Container>
      </section>
    </>
  );
};
export default LinkGroup;
